import type { FC } from "react";
import type { Control, Path } from "react-hook-form";

import { CustomLabel, CustomTooltip } from "@/components/atoms";
import { InputControl } from "@/components/molecules";
import { TooltipProvider } from "@/components/ui/tooltip";

import type { DishFormType } from "../BrandFormMenu/types";

interface NutritionField {
  name: Path<DishFormType>;
  label: string;
}

interface NutritionElementProps {
  elem: NutritionField;
  form: Control<DishFormType>;
}

const NutritionElement: FC<NutritionElementProps> = ({ form, elem }) => {
  return (
    <TooltipProvider>
      <li className="relative grid grid-cols-2">
        <div className="flex items-center justify-between">
          <CustomLabel
            htmlFor={elem.name}
            label={elem.label}
            className="self-center"
          />
          <CustomTooltip
            data-testid={`nutrition-element-tooltip-${elem.label}`}
          >
            food consisting largely of proteins and making up one of the main
            nutritional.
          </CustomTooltip>
        </div>

        <InputControl
          formControl={form}
          nameField={elem.name}
          placeholder="0"
          classedName="mb-0"
          data-testid={`nutrition-element-input-${elem.label}`}
        />
      </li>
    </TooltipProvider>
  );
};

export default NutritionElement;
